module.exports = __webpack_public_path__ + "static/media/rentiranje.86669b2f.jpg";